export default "/images/SL_equipements-2.png?562f25e5ded583ece5e1d46894f32704";